import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/valendris-logo.png';
import './Navigation.scss';

function Navigation() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  // Close menu on route change
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <nav className="navigation">
      <div className="navigation-container container">
        <Link to="/" className="navigation-logo" onClick={closeMenu}>
          <img src={logo} alt="Valendris" className="navigation-logo-image" />
          <span className="navigation-logo-text">Valendris</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="navigation-right navigation-right--desktop">
          <ul className="navigation-links">
            <li>
              <Link
                to="/"
                className={`navigation-link ${isActive('/') ? 'navigation-link--active' : ''}`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/how-we-work"
                className={`navigation-link ${isActive('/how-we-work') ? 'navigation-link--active' : ''}`}
              >
                How I Work
              </Link>
            </li>
          </ul>
          <Link to="/contact" className="navigation-cta">
            Start a Project
          </Link>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          className={`navigation-hamburger ${isMenuOpen ? 'navigation-hamburger--open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span className="navigation-hamburger-line" />
          <span className="navigation-hamburger-line" />
          <span className="navigation-hamburger-line" />
        </button>

        {/* Mobile Menu Overlay */}
        <div className={`navigation-mobile ${isMenuOpen ? 'navigation-mobile--open' : ''}`}>
          <ul className="navigation-mobile-links">
            <li>
              <Link
                to="/"
                className={`navigation-mobile-link ${isActive('/') ? 'navigation-mobile-link--active' : ''}`}
                onClick={closeMenu}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/how-we-work"
                className={`navigation-mobile-link ${isActive('/how-we-work') ? 'navigation-mobile-link--active' : ''}`}
                onClick={closeMenu}
              >
                How I Work
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`navigation-mobile-link ${isActive('/contact') ? 'navigation-mobile-link--active' : ''}`}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </li>
          </ul>
          <Link to="/contact" className="navigation-mobile-cta" onClick={closeMenu}>
            Start a Project
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
